import { checkLogin } from "actions/AuthAction";
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
//import { useDispatch, useSelector } from 'react-redux';

import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Badge,
  Progress,
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  Button,
} from "reactstrap";

import Map from "../components/am4chartMap/am4chartMap";
import Header from "components/Header/Header";
import Footer_New from "components/Footer-New/Footer-New";
import LoginModal from "components/LoginModal/LoginModal";
import { useLoginModal } from "../contexts/LoginModalContext";
import { API_LANDING_BERANDA, API_STOK_DARAH } from "utils";

function LandingPage() {
  // const dispatch = useDispatch();
  const history = useHistory();
  const { isOpen, toggleModal } = useLoginModal();
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Data stok darah (akan diambil dari API)
  const [stokDarah, setStokDarah] = useState({});

  // Data statistik (akan diambil dari API)
  const [statistik, setStatistik] = useState({
    totalPendonor: 0,
    donorBulanIni: 0,
    donorMingguIni: 0,
    totalKantong: 0,
  });

  const totalStokSemua = useMemo(() => {
    return Object.values(stokDarah || {}).reduce(
      (sum, item) => sum + (item?.stok || 0),
      0
    );
  }, [stokDarah]);

  // Foto aktivitas PMI dari folder public
  const [fotoAktivitas] = useState([
    "/donor1.jpg",
    "/donor2.jpeg",
    "/donor3.jpg",
    "/donor4.jpg",
    "/donor5.jpeg",
    "/donor6.jpeg",
    "/donor7.jpg",
  ]);

  // const { loginLoading, loginResult, loginError, checkLoginResult } =
  //   useSelector((state) => state.AuthReducer);

  useEffect(() => {
    checkLogin(history);
    const fetchLandingData = async () => {
      // Ambil statistik beranda
      try {
        const resStat = await axios.get(API_LANDING_BERANDA, {
          timeout: 120000,
        });
        if (resStat.data?.success) {
          const data = resStat.data.data || {};
          setStatistik({
            totalPendonor: data.total_pendonor || 0,
            donorBulanIni: data.donor_bulan_ini || 0,
            donorMingguIni: data.donor_minggu_ini || 0,
            totalKantong: data.total_kantong || 0,
          });
        }
      } catch (error) {
        console.error("Error fetch statistik landing:", error);
      }

      // Ambil stok darah
      try {
        const resStok = await axios.get(API_STOK_DARAH, { timeout: 120000 });
        if (resStok.data?.success && Array.isArray(resStok.data.data)) {
          const normalized = resStok.data.data.reduce((acc, item) => {
            const stok = item.stok_kantung || 0;
            const target = Math.max(item.total_masuk || stok || 0, 50);
            const status = stok < target * 0.6 ? "kurang" : "cukup";
            const gol = item.golonganDarah || `ID-${item.bloodTypeID}`;
            acc[gol] = { stok, target, status };
            return acc;
          }, {});
          setStokDarah(normalized);
        }
      } catch (error) {
        console.error("Error fetch stok landing:", error);
      }
    };

    fetchLandingData();
  }, [history]);

  const next = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === fotoAktivitas.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex =
      activeIndex === 0 ? fotoAktivitas.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = fotoAktivitas.map((foto, index) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={index}
        style={{
          position: "relative",
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "500px",
            overflow: "hidden",
            borderRadius: "16px",
          }}
        >
          <img
            src={foto}
            alt={`Aktivitas Donor Darah ${index + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background:
                "linear-gradient(to top, rgba(0,0,0,0.5), transparent)",
              padding: "30px",
              color: "#ffffff",
            }}
          >
            <h5 style={{ margin: 0, fontSize: "1.2rem", fontWeight: "500" }}>
              Aktivitas Donor Darah {index + 1}
            </h5>
            <p
              style={{ margin: "5px 0 0 0", fontSize: "0.9rem", opacity: 0.9 }}
            >
              Palang Merah Indonesia
            </p>
          </div>
        </div>
      </CarouselItem>
    );
  });

  // useEffect(() => {
  // if (checkLoginResult) {
  //   history.push('/admin/dashboard');
  // }

  //   if (loginResult) {
  //     history.push('/admin/dashboard');
  //   }
  // }, [loginResult]);

  return (
    <>
      <Header />
      <LoginModal isOpen={isOpen} toggle={toggleModal} />
      <div
        className="content"
        style={{
          margin: isMobile ? 10 : 20,
          background: "#ffffff",
          minHeight: "100vh",
          padding: isMobile ? "10px 0" : "20px 0",
        }}
      >
        {/* Banner Section */}
        <Row>
          <Col xs="12">
            <Card
              style={{
                position: "relative",
                borderRadius: "20px",
                overflow: "hidden",
                border: "none",
                boxShadow: "0 4px 25px rgba(0, 0, 0, 0.1)",
                marginBottom: "50px",
              }}
            >
              <img
                src="/Banner.png"
                alt="Banner Donor Darah"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "cover",
                }}
              />
            </Card>
          </Col>
        </Row>

        {/* Statistik Utama */}
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col lg="3" md="6" sm="12" style={{ marginBottom: "20px" }}>
            <Card
              style={{
                background: "#ffffff",
                color: "#2d3436",
                borderRadius: isMobile ? "12px" : "16px",
                textAlign: "center",
                padding: isMobile ? "25px 15px" : "35px 20px",
                border: "none",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 12px rgba(0,0,0,0.06)";
                }
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "2rem" : "2.5rem",
                  marginBottom: "15px",
                  color: "#e63946",
                }}
              >
                👥
              </div>
              <h2
                style={{
                  fontSize: isMobile ? "2rem" : "2.8rem",
                  fontWeight: "300",
                  margin: "15px 0",
                  color: "#2d3436",
                }}
              >
                {statistik.totalPendonor.toLocaleString()}
              </h2>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  margin: 0,
                  color: "#636e72",
                  fontWeight: "400",
                }}
              >
                Total Donatur
              </p>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="12" style={{ marginBottom: "20px" }}>
            <Card
              style={{
                background: "#ffffff",
                color: "#2d3436",
                borderRadius: isMobile ? "12px" : "16px",
                textAlign: "center",
                padding: isMobile ? "25px 15px" : "35px 20px",
                border: "none",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 12px rgba(0,0,0,0.06)";
                }
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "2rem" : "2.5rem",
                  marginBottom: "15px",
                  color: "#06d6a0",
                }}
              >
                📅
              </div>
              <h2
                style={{
                  fontSize: isMobile ? "2rem" : "2.8rem",
                  fontWeight: "300",
                  margin: "15px 0",
                  color: "#2d3436",
                }}
              >
                {statistik.donorBulanIni}
              </h2>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  margin: 0,
                  color: "#636e72",
                  fontWeight: "400",
                }}
              >
                Donor Bulan Ini
              </p>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="12" style={{ marginBottom: "20px" }}>
            <Card
              style={{
                background: "#ffffff",
                color: "#2d3436",
                borderRadius: isMobile ? "12px" : "16px",
                textAlign: "center",
                padding: isMobile ? "25px 15px" : "35px 20px",
                border: "none",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 12px rgba(0,0,0,0.06)";
                }
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "2rem" : "2.5rem",
                  marginBottom: "15px",
                  color: "#118ab2",
                }}
              >
                📆
              </div>
              <h2
                style={{
                  fontSize: isMobile ? "2rem" : "2.8rem",
                  fontWeight: "300",
                  margin: "15px 0",
                  color: "#2d3436",
                }}
              >
                {statistik.donorMingguIni}
              </h2>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  margin: 0,
                  color: "#636e72",
                  fontWeight: "400",
                }}
              >
                Donor Minggu Ini
              </p>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="12" style={{ marginBottom: "20px" }}>
            <Card
              style={{
                background: "#ffffff",
                color: "#2d3436",
                borderRadius: isMobile ? "12px" : "16px",
                textAlign: "center",
                padding: isMobile ? "25px 15px" : "35px 20px",
                border: "none",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 20px rgba(0,0,0,0.1)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isMobile) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 12px rgba(0,0,0,0.06)";
                }
              }}
            >
              <div
                style={{
                  fontSize: isMobile ? "2rem" : "2.5rem",
                  marginBottom: "15px",
                  color: "#ffb703",
                }}
              >
                🩸
              </div>
              <h2
                style={{
                  fontSize: isMobile ? "2rem" : "2.8rem",
                  fontWeight: "300",
                  margin: "15px 0",
                  color: "#2d3436",
                }}
              >
                {statistik.totalKantong.toLocaleString()}
              </h2>
              <p
                style={{
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  margin: 0,
                  color: "#636e72",
                  fontWeight: "400",
                }}
              >
                Total Stok Darah
              </p>
            </Card>
          </Col>
        </Row>

        {/* Stok Darah RSUD Ba'a */}
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col xs="12">
            <Card
              style={{
                borderRadius: isMobile ? "15px" : "20px",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
                border: "none",
                overflow: "hidden",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: isMobile ? "20px 15px" : "30px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: isMobile ? "flex-start" : "center",
                    flexDirection: isMobile ? "column" : "row",
                    gap: "10px",
                  }}
                >
                  <CardTitle
                    tag="h4"
                    style={{
                      color: "#2d3436",
                      margin: 0,
                      fontWeight: "400",
                      fontSize: isMobile ? "1.2rem" : "1.5rem",
                    }}
                  >
                    📊 Stok Darah - Rumah Sakit Umum Daerah Ba'a
                  </CardTitle>
                  <div
                    style={{
                      marginLeft: isMobile ? 0 : "auto",
                      color: "#636e72",
                      fontSize: isMobile ? "0.9rem" : "1rem",
                    }}
                  >
                    Total stok:{" "}
                    <strong style={{ color: "#2d3436" }}>
                      {totalStokSemua} kantong
                    </strong>
                  </div>
                </div>
              </CardHeader>
              <CardBody
                style={{ padding: isMobile ? "20px 15px" : "40px 30px" }}
              >
                {Object.keys(stokDarah || {}).length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#636e72",
                      padding: "15px 0",
                    }}
                  >
                    Tidak ada data stok darah.
                  </div>
                ) : (
                  <Row>
                    {Object.entries(stokDarah).map(([golongan, data]) => (
                      <Col
                        lg="3"
                        md="6"
                        sm="12"
                        key={golongan}
                        style={{ marginBottom: "25px" }}
                      >
                        <Card
                          style={{
                            border: `1px solid ${
                              data.status === "kurang" ? "#ffe0e0" : "#e0f5e9"
                            }`,
                            borderRadius: "16px",
                            padding: "30px 20px",
                            textAlign: "center",
                            background:
                              data.status === "kurang" ? "#fff5f5" : "#f8fff9",
                            transition: "all 0.3s ease",
                          }}
                          onMouseEnter={(e) => {
                            if (!isMobile) {
                              e.currentTarget.style.transform =
                                "translateY(-3px)";
                              e.currentTarget.style.boxShadow =
                                "0 4px 15px rgba(0,0,0,0.1)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isMobile) {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "none";
                            }
                          }}
                        >
                          <h3
                            style={{
                              fontSize: isMobile ? "2.5rem" : "3rem",
                              fontWeight: "300",
                              color:
                                data.status === "kurang"
                                  ? "#e63946"
                                  : "#06d6a0",
                              margin: "15px 0",
                              letterSpacing: "2px",
                            }}
                          >
                            {golongan}
                          </h3>
                          <p
                            style={{
                              fontSize: isMobile ? "0.9rem" : "1rem",
                              margin: "15px 0",
                              color: "#636e72",
                            }}
                          >
                            <strong
                              style={{
                                color: "#2d3436",
                                fontSize: isMobile ? "1.1rem" : "1.3rem",
                              }}
                            >
                              {data.stok}
                            </strong>{" "}
                            / {data.target} kantong
                          </p>
                          <Progress
                            value={(data.stok / data.target) * 100}
                            color={
                              data.status === "kurang" ? "danger" : "success"
                            }
                            style={{
                              height: "8px",
                              borderRadius: "10px",
                              marginTop: "15px",
                              backgroundColor: "#f1f3f5",
                            }}
                          />
                          <Badge
                            style={{
                              marginTop: "15px",
                              fontSize: "0.85rem",
                              padding: "6px 12px",
                              borderRadius: "20px",
                              fontWeight: "400",
                              background:
                                data.status === "kurang"
                                  ? "#ffe0e0"
                                  : "#e0f5e9",
                              color:
                                data.status === "kurang"
                                  ? "#e63946"
                                  : "#06d6a0",
                              border: "none",
                            }}
                          >
                            {data.status === "kurang"
                              ? "⚠️ Stok Kurang"
                              : "✅ Stok Cukup"}
                          </Badge>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Informasi Penting */}
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col lg="6" md="12" style={{ marginBottom: "25px" }}>
            <Card
              style={{
                borderRadius: isMobile ? "15px" : "20px",
                height: "100%",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: isMobile ? "20px 15px" : "30px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "400",
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                >
                  📅 Jadwal Donor Darah
                </CardTitle>
              </CardHeader>
              <CardBody style={{ padding: "30px" }}>
                <Table style={{ marginBottom: "25px" }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: "15px 0", color: "#2d3436" }}>
                        <strong style={{ fontWeight: "600" }}>
                          Layanan 24 Jam
                        </strong>
                      </td>
                      <td
                        style={{
                          padding: "15px 0",
                          color: "#636e72",
                          textAlign: "right",
                        }}
                      >
                        Setiap hari (24/7)
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div
                  style={{
                    marginTop: "20px",
                    padding: "20px",
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    border: "1px solid #e9ecef",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "0.95rem",
                      color: "#636e72",
                      lineHeight: "1.8",
                    }}
                  >
                    <strong style={{ color: "#2d3436" }}>📍 Lokasi:</strong>{" "}
                    Laboratorium Rumah Sakit Umum Daerah Kab. Rote Ndao
                    <br />
                    <strong style={{ color: "#2d3436" }}>
                      📞 Kontak:
                    </strong>{" "}
                    (0381) 1234567
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6" md="12" style={{ marginBottom: "25px" }}>
            <Card
              style={{
                borderRadius: "20px",
                height: "100%",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: "30px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "400",
                    fontSize: "1.5rem",
                  }}
                >
                  ℹ️ Syarat Donor Darah
                </CardTitle>
              </CardHeader>
              <CardBody style={{ padding: "30px" }}>
                <ul
                  style={{
                    paddingLeft: "20px",
                    marginBottom: "25px",
                    color: "#636e72",
                    lineHeight: "2",
                  }}
                >
                  <li style={{ marginBottom: "10px" }}>
                    Usia 17-60 tahun (usia 17 tahun harus dengan izin orang tua)
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Berat badan minimal 45 kg
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Tekanan darah Sistolik 90 hingga 160 mm Hg, Diastolik 60
                    hingga 100 mm Hg, dengan perbedaan antara Sistolik dan
                    Diastolik lebih dari 20 mm Hg
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Kadar hemoglobin minimal 12,5 gr% untuk wanita dan 13 gr%
                    untuk pria
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Interval donor minimal 3 bulan sekali
                  </li>
                  <li style={{ marginBottom: "10px" }}>
                    Dalam 3 hari terakhir tidak mengonsumsi obat apapun
                  </li>
                  <li>Sehat jasmani dan rohani</li>
                </ul>
                <div
                  style={{
                    marginTop: "20px",
                    padding: "20px",
                    background: "#fff9e6",
                    borderRadius: "12px",
                    border: "1px solid #ffeaa7",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "0.95rem",
                      color: "#636e72",
                      lineHeight: "1.8",
                    }}
                  >
                    <strong style={{ color: "#2d3436" }}>⚠️ Catatan:</strong>{" "}
                    Jangan lupa membawa KTP atau identitas lainnya saat
                    mendonor.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Gallery Foto Aktivitas PMI - Slider */}
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col xs="12">
            <Card
              style={{
                borderRadius: isMobile ? "15px" : "20px",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: isMobile ? "20px 15px" : "30px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "400",
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                >
                  📸 Aktivitas Donor Darah - Palang Merah Indonesia
                </CardTitle>
              </CardHeader>
              <CardBody style={{ padding: "0" }}>
                <div style={{ position: "relative" }}>
                  <Carousel
                    activeIndex={activeIndex}
                    next={next}
                    previous={previous}
                    style={{
                      borderRadius: "16px",
                      overflow: "hidden",
                    }}
                  >
                    {slides}
                    <CarouselControl
                      direction="prev"
                      directionText="Previous"
                      onClickHandler={previous}
                    />
                    <CarouselControl
                      direction="next"
                      directionText="Next"
                      onClickHandler={next}
                    />
                  </Carousel>
                  <div
                    style={{
                      position: "absolute",
                      bottom: "20px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 15,
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    {fotoAktivitas.map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => goToIndex(idx)}
                        style={{
                          width: activeIndex === idx ? "30px" : "10px",
                          height: "10px",
                          borderRadius: "5px",
                          border: "none",
                          background:
                            activeIndex === idx
                              ? "#ffffff"
                              : "rgba(255, 255, 255, 0.5)",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          padding: 0,
                        }}
                      />
                    ))}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Peta */}
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col xs="12">
            <Card
              className="card-chart"
              style={{
                padding: 0,
                borderRadius: isMobile ? "15px" : "20px",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
                overflow: "hidden",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: isMobile ? "20px 15px" : "30px 40px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "400",
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                >
                  🗺️ Peta Lokasi Unit Transfusi Darah
                </CardTitle>
              </CardHeader>
              <div style={{ padding: isMobile ? "15px" : "40px" }}>
                <Map />
              </div>
            </Card>
          </Col>
        </Row>

        {/* Section Permintaan Donor Darah */}
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col xs="12">
            <Card
              style={{
                borderRadius: isMobile ? "15px" : "20px",
                border: "none",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
                overflow: "hidden",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              }}
            >
              <CardBody
                style={{
                  padding: isMobile ? "30px 20px" : "50px 40px",
                  textAlign: "center",
                  color: "#ffffff",
                }}
              >
                <h3
                  style={{
                    fontSize: isMobile ? "1.5rem" : "2rem",
                    fontWeight: "500",
                    marginBottom: "15px",
                    color: "#ffffff",
                  }}
                >
                  🩸 Ingin Membantu Mengisi Stok Darah?
                </h3>
                <p
                  style={{
                    fontSize: isMobile ? "1rem" : "1.2rem",
                    marginBottom: "30px",
                    opacity: 0.95,
                    color: "#ffffff",
                  }}
                >
                  Lihat daftar permintaan donor darah dari Bank Darah RSUD Ba'a
                  dan respon jika Anda bersedia membantu.
                </p>
                <Button
                  color="light"
                  size="lg"
                  onClick={() => {
                    window.location.href = "/#/permintaan-donor-publik";
                  }}
                  style={{
                    borderRadius: "30px",
                    padding: "15px 40px",
                    fontSize: "1.1rem",
                    fontWeight: "500",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(0,0,0,0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(0,0,0,0.2)";
                  }}
                >
                  Lihat Permintaan Donor Darah
                </Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      <Footer_New />
    </>
  );
}

export default LandingPage;
